import React, { ReactElement } from 'react'

export type TwoColumnSelectOptionProps = {
    label: string
    value: string
}

/**
 *
 * @param label Label to be rendered in right column.
 * @param value Value to be rendered in left column.
 *
 */
const TwoColumnSelectOption: React.FC<TwoColumnSelectOptionProps> = ({
    label,
    value
}: TwoColumnSelectOptionProps): ReactElement => (
    <div className='two-column-select-option'>
        <span className='two-column-option-left-column' dangerouslySetInnerHTML={{ __html: value }} />
        <span>{label}</span>
    </div>
)
export default TwoColumnSelectOption
